import { Col, Row, Tooltip, Typography } from 'antd'
import { memo } from 'react'
import { D4_Fn_View_Demande } from '../../types'
import DemandeDetailTags from './DemandeDetailTags'

const DemandeDescriptionCell = memo(({ text, item }: { text: string; item: D4_Fn_View_Demande }) => {
  return (
    <Row justify="space-between" style={{ width: '100%' }}>
      <Col flex="none">
        <div style={{ cursor: 'pointer' }}>
          <Tooltip placement="topLeft" title={text}>
            <Typography.Text ellipsis strong={item.etatdemande === 0} style={{ maxWidth: '100%' }}>
              {text}
            </Typography.Text>
          </Tooltip>
        </div>
      </Col>
      <Col flex="auto">
        <Row justify="end" style={{ width: '100%' }}>
          <Col>
            <DemandeDetailTags item={item} />
          </Col>
        </Row>
      </Col>
    </Row>
  )
})

export default DemandeDescriptionCell
